import React from 'react'
import { Admin, Resource, Delete } from 'admin-on-rest'
import { Route } from 'react-router-dom'
import PackageIcon from 'material-ui/svg-icons/action/card-travel'
import ProductsIcon from 'material-ui/svg-icons/action/shopping-basket'
import CountryIcon from 'material-ui/svg-icons/maps/place'
import PriceIcon from 'material-ui/svg-icons/action/euro-symbol'
import ShopIcon from 'material-ui/svg-icons/action/shop'
import OfferIcon from 'material-ui/svg-icons/maps/local-offer'
import TranslateIcon from 'material-ui/svg-icons/action/translate'
import authClient from './authClient'
import myApiRestClient from './restClient'
import addUploadFeature from './addUploadFeature'
import { PackageList, PackageEdit, PackageCreate } from './packageTemplates'
import { CouponList, CouponCreate, CouponShow } from './coupons'
import { ProductList, ProductEdit, ProductCreate } from './products'
import { CountryList, CountryEdit } from './countries'
import { PriceList, PriceEdit } from './packages'
import { ShopList, ShopEdit } from './shops'
import { OfferCreate, OfferEdit, OfferList } from './offers'
import { TranslationCreate, TranslationEdit, TranslationList } from './translations'
import Subscribe from './components/subscribe';
import CouponActivation from './components/coupon';
import PublicTimelineWidget from './components/widgets/public-timeline';

const uploadCapableClient = addUploadFeature(myApiRestClient)
const customRoutes = [
    <Route exact path="/email/unsubscribe/:hash" component={Subscribe} noLayout />,
    <Route exact path="/coupons/activation/:locale/:hash" component={CouponActivation} noLayout />,
    <Route exact path="/widgets/public-timeline" component={PublicTimelineWidget} noLayout />
]

const App = () => (
  <Admin authClient={authClient} customRoutes={customRoutes} restClient={uploadCapableClient} title={'Fortunica Marketing Admin'}>
    <Resource
      name="packageTemplates"
      options={{ label: 'Package Templates' }}
      create={PackageCreate}
      list={PackageList}
      edit={PackageEdit}
      remove={Delete}
      icon={PackageIcon}
    />
    <Resource
      name="products"
      options={{ label: 'Ritual Templates' }}
      create={ProductCreate}
      edit={ProductEdit}
      remove={Delete}
      icon={ProductsIcon}
      list={ProductList}
    />
    <Resource name="countries" list={CountryList} edit={CountryEdit} icon={CountryIcon} />
    <Resource name="packages" list={PriceList} edit={PriceEdit} icon={PriceIcon} />
    <Resource name="shops" list={ShopList} edit={ShopEdit} icon={ShopIcon} />
    <Resource name="offers" list={OfferList} create={OfferCreate} edit={OfferEdit} remove={Delete} icon={OfferIcon} />
    <Resource name="translations" list={TranslationList} create={TranslationCreate} edit={TranslationEdit} icon={TranslateIcon} />
    <Resource name="currencies" />
    <Resource name="paymentmethods" />
    <Resource name="languages" />
    <Resource name="coupons" list={CouponList} create={CouponCreate} show={CouponShow} />
  </Admin>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js